/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Organize_TipInputs */

const en_pc_tut_organize_tip = /** @type {(inputs: Pc_Tut_Organize_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Edit menu names each step, for example “Undo Rotate pages”, so you always know what you are undoing.`)
};

const zh_pc_tut_organize_tip = /** @type {(inputs: Pc_Tut_Organize_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「Edit」菜单会写明每一步，比如「Undo Rotate pages」，你始终知道自己在撤销什么。`)
};

/**
* | output |
* | --- |
* | "The Edit menu names each step, for example “Undo Rotate pages”, so you always know what you are undoing." |
*
* @param {Pc_Tut_Organize_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_organize_tip = /** @type {((inputs?: Pc_Tut_Organize_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Organize_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_organize_tip(inputs)
	return zh_pc_tut_organize_tip(inputs)
});
export { pc_tut_organize_tip as "pc.tut.organize.tip" }